module.exports = __webpack_public_path__ + "img/zi_1.6e4744f9.png";